import { 
  Scale, 
  FileText, 
  Camera, 
  Gavel, 
  Mail, 
  Image, 
  Video, 
  Headphones,
  Plus,
  DollarSign
} from 'lucide-react'
import { DocumentModuleConfig, DocumentTypeConfig } from '../types/document-types'

export const CASE_DOCUMENT_TYPES: DocumentTypeConfig[] = [
  {
    key: 'PETITION',
    label: 'Petição',
    icon: Scale,
    color: 'purple',
    allowedMimeTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    maxSizeInMB: 50,
    confidentialByDefault: true,
    description: 'Petições iniciais, contestações, recursos'
  },
  {
    key: 'CONTRACT',
    label: 'Contrato',
    icon: FileText,
    color: 'blue',
    allowedMimeTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    maxSizeInMB: 30,
    confidentialByDefault: true,
    description: 'Contratos relacionados ao processo'
  },
  {
    key: 'EVIDENCE',
    label: 'Evidência',
    icon: Camera,
    color: 'red',
    allowedMimeTypes: [
      'application/pdf',
      'image/jpeg', 
      'image/png', 
      'image/gif',
      'video/mp4',
      'video/avi',
      'audio/mp3',
      'audio/wav'
    ],
    maxSizeInMB: 100,
    confidentialByDefault: false,
    description: 'Provas, fotos, vídeos, áudios'
  },
  {
    key: 'COURT_DECISION',
    label: 'Decisão Judicial',
    icon: Gavel,
    color: 'indigo',
    allowedMimeTypes: ['application/pdf'],
    maxSizeInMB: 20,
    confidentialByDefault: false,
    description: 'Sentenças, despachos, decisões'
  },
  {
    key: 'CORRESPONDENCE',
    label: 'Correspondência',
    icon: Mail,
    color: 'green',
    allowedMimeTypes: ['application/pdf', 'image/jpeg', 'image/png'],
    maxSizeInMB: 15,
    description: 'Ofícios, comunicações, intimações'
  },
  {
    key: 'PHOTO',
    label: 'Foto',
    icon: Image,
    color: 'yellow',
    allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif'],
    maxSizeInMB: 25,
    description: 'Fotografias relacionadas ao caso'
  },
  {
    key: 'VIDEO',
    label: 'Vídeo',
    icon: Video,
    color: 'pink',
    allowedMimeTypes: ['video/mp4', 'video/avi', 'video/mov'],
    maxSizeInMB: 200,
    description: 'Gravações em vídeo'
  },
  {
    key: 'AUDIO',
    label: 'Áudio',
    icon: Headphones,
    color: 'cyan',
    allowedMimeTypes: ['audio/mp3', 'audio/wav', 'audio/m4a'],
    maxSizeInMB: 50,
    description: 'Gravações em áudio'
  },
  {
    key: 'MEDICAL_REPORT',
    label: 'Relatório Médico',
    icon: Plus,
    color: 'emerald',
    allowedMimeTypes: ['application/pdf', 'image/jpeg', 'image/png'],
    maxSizeInMB: 30,
    confidentialByDefault: true,
    description: 'Laudos, exames médicos'
  },
  {
    key: 'FINANCIAL_DOCUMENT',
    label: 'Documento Financeiro',
    icon: DollarSign,
    color: 'amber',
    allowedMimeTypes: [
      'application/pdf',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    maxSizeInMB: 20,
    confidentialByDefault: true,
    description: 'Extratos, comprovantes, planilhas'
  },
  {
    key: 'OTHER',
    label: 'Outro',
    icon: FileText,
    color: 'gray',
    allowedMimeTypes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'image/jpeg',
      'image/png',
      'text/plain'
    ],
    maxSizeInMB: 50,
    description: 'Outros documentos não categorizados'
  }
]

export const CASE_DOCUMENT_CONFIG: DocumentModuleConfig = {
  entityType: 'case',
  entityName: 'Caso',
  title: 'Documentos do Caso',
  documentTypes: CASE_DOCUMENT_TYPES,
  features: {
    confidential: true, // Casos têm suporte a documentos confidenciais
    versioning: true,   // Versionamento de petições
    categories: true,
    preview: true,
    bulkOperations: true, // Upload múltiplo de evidências
    dragDrop: true,
    search: true
  },
  ui: {
    modalMode: true, // Modal popup moderno
    showDescription: false, // Usa título ao invés de descrição
    showTags: false, // a API não guarda etiquetas de documento
    maxFilesAtOnce: 5,
    allowedFileTypes: [
      '.pdf', '.doc', '.docx', 
      '.jpg', '.jpeg', '.png', '.gif',
      '.mp4', '.avi', '.mov',
      '.mp3', '.wav', '.m4a',
      '.txt', '.xls', '.xlsx'
    ],
    maxFileSize: 200 * 1024 * 1024 // 200MB para vídeos
  }
}